import React from 'react';
import styled from 'styled-components';
import { Center, InteractiveStyle, Padding, Queue } from '../layout';
import { Border } from './border';
import { Text } from './text';

const RawButton = (props) => {
  let { children, backgroundRole, textRole } = props;
  return (
    <Border {...props}>
      <Center height="100%" backgroundRole={backgroundRole}>
        <Padding size={[3, 6]}>
          <Queue size={2}>
            <Text nowrap vertical="top" textType="primary3" textRole={textRole}>
              {children}
            </Text>
          </Queue>
        </Padding>
      </Center>
    </Border>
  );
};

export const Button = styled(RawButton)`
  display: inline-block;
  overflow: hidden;
  ${InteractiveStyle}
`;
